export enum LeaveStages {
    DeterminingEligibility = -1,
    DeterminingApproval = -2,
    LeavePending = -3,
    ReadyForLeave = -4,
    OnLeave = -5,
    LeaveCompleted = -6
}